import React from "react";
import { Box, Button, Typography } from "@mui/material";

const CluppNumberRange = ({
  maxNumber,
  setState,
  state,
  field,
  labels = {
    startLabel: "",
    middleLabel: "",
    endLabel: "",
  },
}) => {
  const [selectedNumber, setSelectedNumber] = React.useState(state[field]);

  const handleNumberClick = (number) => {
    setSelectedNumber(number);
    setState((prev) => ({
      ...prev,
      [field]: number,
    }));
  };

  const renderLabels = () => {
    const labelsRender = [];
    if (labels.startLabel) {
      labelsRender.push(
        <Typography key="startLabel" color="#2CC1F0">
          {labels.startLabel}
        </Typography>
      );
    }
    if (labels.middleLabel) {
      labelsRender.push(
        <Typography
          key="middleLabel"
          sx={{ textAlign: "center", color: "#2CC1F0" }}
        >
          {labels.middleLabel}
        </Typography>
      );
    }
    if (labels.endLabel) {
      labelsRender.push(
        <Typography
          key="endLabel"
          sx={{ textAlign: "right", color: "#2CC1F0" }}
        >
          {labels.endLabel}
        </Typography>
      );
    }
    return labelsRender;
  };

  return (
    <Box sx={{ width: "100%", margin: "20px 0", padding: 0 }}>
      <Box
        display="flex"
        justifyContent={"center"}
        sx={{
          width: "100%",
          margin: 0,
          padding: 0,
        }}
        flexWrap={"wrap"}
      >
        {Array.from({ length: maxNumber }, (_, index) => (
          <Box
            disableElevation
            key={index + 1}
            sx={{
              minHeight: "25px",
              minWidth: "25px",
              margin: "2px",
              padding: "10px",
              fontSize: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #2CC1F0",
              color: selectedNumber === index + 1 ? "#fff" : "#2CC1F0",
              backgroundColor:
                selectedNumber === index + 1 ? "#2CC1F0" : "#E5F8FD",
              borderRadius: "4px",
            }}
            variant={selectedNumber === index + 1 ? "contained" : "outlined"}
            onClick={() => handleNumberClick(index + 1)}
          >
            {index + 1}
          </Box>
        ))}
      </Box>
      <Box display={["none", "flex"]} justifyContent="space-between" mt={1}>
        {renderLabels()}
      </Box>
    </Box>
  );
};

export default CluppNumberRange;
